<template>
    <div class="font-weight-bold text-center m-auto"
         style="font-size: 1.2rem;width: 300px">
        {{ text }}
    </div>
</template>

<script>
export default {
    name: "EmptyListInfo",
    props: {
        text: {
            type: String,
            default: '无记录'
        }
    }
}
</script>

<style scoped>

</style>